import React, { PureComponent } from 'react'
import { translate } from 'react-i18next'
import { ImageAndText, Text } from 'components'


import './Item3.css'

@translate()
export class Item3 extends PureComponent {
    render() {
        const { t, className } = this.props

        return (
            <div className="item3">
                <ImageAndText image={{ src: '/assets/carousel/helmet.svg', style: { width: '100%', height: '170px', marginBottom: '76px' } }} text={t('onboarding.carousel.item3.title')} className="item3-content" />
<Text tag="p" className="item3-content-subtitle" dangerouslySetInnerHTML={{ __html: t('onboarding.carousel.item3.subtitle') }} />

            </div>
        )
    }
}



// WEBPACK FOOTER //
// src/components/Carousel/Items/Item3.js